import React, { useCallback } from "react";

import { DialogActions } from "@material-ui/core";
import { useFormikContext } from "formik";

import { useSubmitHandler } from "components/Form/FormikControls";

import { Button, SecondaryButton } from "components/Form";
import {
  MobileTransactionalCreateSaleModalTabId,
  MobileTransactionalCreateSaleModalTabOrder,
} from "./constants";

interface ActionsProps {
  onClose: () => void;
  activeTab: MobileTransactionalCreateSaleModalTabId;
  setActiveTab: (id: MobileTransactionalCreateSaleModalTabId) => void;
}

export const Actions = ({ onClose, activeTab, setActiveTab }: ActionsProps) => {
  const { submitForm, isSubmitting } = useFormikContext();

  const [isSubmitEnabled, setIsSubmitEnabled] = React.useState(false);
  useSubmitHandler(false, setIsSubmitEnabled);

  const currentTabIndex =
    MobileTransactionalCreateSaleModalTabOrder.indexOf(activeTab);
  const isLastTab =
    currentTabIndex === MobileTransactionalCreateSaleModalTabOrder.length - 1;
  const isFirstTab = currentTabIndex === 0;

  const handleNext = useCallback(
    (submit: () => void) => {
      if (isLastTab) {
        submit();
      } else {
        setActiveTab(
          MobileTransactionalCreateSaleModalTabOrder[currentTabIndex + 1],
        );
      }
    },
    [currentTabIndex, isLastTab, setActiveTab],
  );

  const handleBack = useCallback(() => {
    setActiveTab(
      MobileTransactionalCreateSaleModalTabOrder[currentTabIndex - 1],
    );
  }, [currentTabIndex, setActiveTab]);

  const buttonStyle = { minHeight: 44 };

  return (
    <DialogActions>
      <SecondaryButton
        onClick={isFirstTab ? onClose : handleBack}
        inline
        border={false}
        style={buttonStyle}
      >
        {isFirstTab ? "Close" : "Back"}
      </SecondaryButton>
      {!isLastTab && (
        <SecondaryButton
          onClick={submitForm}
          disabled={!isSubmitEnabled}
          inline
          style={buttonStyle}
        >
          Save & Close
        </SecondaryButton>
      )}
      <Button
        onClick={() => handleNext(submitForm)}
        disabled={isSubmitting || (isLastTab && !isSubmitEnabled)}
        inline
        style={buttonStyle}
      >
        {isLastTab ? "Save" : "Next"}
      </Button>
    </DialogActions>
  );
};
